import { IQualityEffect } from 'types/qualities';

export default function parseChangeMessage(m: IQualityEffect) {
  try {
    return {
      // Clobber 'BasicAbility' because we don't use it in the Myself qual categories
      category: m.category === 'BasicAbility' ? '' : m.category,
      id: m.qualityId,
      name: m.qualityName,
      level: m.levelAfter,
      possession: m.possession, // might be undefined? TODO: check with H
    };
  } catch (error) {
    console.error('Error parsing this change message:');
    console.error(m);
    console.error(error);
  }
}